import React from "react";
import { theme, Tooltip, Modal } from 'antd';
import {
  PlusCircleFilled,
  EditOutlined,
  ExclamationCircleOutlined,
  DeleteOutlined
} from '@ant-design/icons';
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { URL_CHEMICAL } from "../../constants/urls";
import { dateTimeToHumanString } from "../../frameworks/Util";
import ErrorMessages from "../../common/ErrorMessages";
import { DELETE } from "../../frameworks/HttpClient";
import AddQualityChemicalModal from "./AddQualityChemicalModal";

export default function QualityChemicalConfigList(props) {                                                                      
  const [ errorMessages, setErrorMessages ] = React.useState(false);
  const [ chemicalTarget, setChemicalTarget] = React.useState(null);
  const tableRef = React.useRef(null);
  const {
    token: { colorSuccess },
  } = theme.useToken(); 

  const { token : { colorError, colorWarning }} = theme.useToken();

  const columns = [
    {
      title: 'Action',
      dataIndex: '',
      width : 150,
      key: 'action',
      render: (_, original) => {
        return (
          <div 
            style={{textAlign:'center'}}
            onClick={(e) => {
              e.stopPropagation()
            }}
          >
            {!original.is_closed && <Tooltip triger='hover' title="ลบชื่อสารเคมี">
              <ColorButton 
                type='primary'
                override={colorError}
                icon={<DeleteOutlined />}
                style={{ margin : 5}}
                onClick={()=> confirm(original.name, original.id)} 
              />
            </Tooltip>}
            {!original.is_closed && <Tooltip triger='hover' title="แก้ไข">
              <ColorButton 
                type='primary'
                override={colorWarning}
                icon={<EditOutlined />}
                style={{ margin : 5}}
                onClick={()=> setChemicalTarget(original)} 
              />
            </Tooltip>}
          </div>
      )}
    },
    {
      title: 'ชื่อสารเคมีคุณภาพ',
      dataIndex: 'name',
      key: 'name',
      searcher : true,
    },
    {
      title: 'งานเติมสาร',
      dataIndex: '',
      key: 'fill',
      render : (value,original) => {
        return (
          <>
          {original.pond ? 'บ่อพักน้ำยางสด' : ''}{original.pond & original.tank ? ',' : '' } {original.tank ? 'แทงก์น้ำยางข้น' : ''}
          </>
        )
      }
    },
    {
      title: 'วันที่สร้าง',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value)
    },
    {
      title: 'วันที่แก้ไขล่าสุด',
      dataIndex: 'updated',
      key: 'updated',
      render : (value) => dateTimeToHumanString(value)
    },
  ]

  const confirm = (title, value) => {
    Modal.confirm({
      title: `ลบชื่อสารเคมี - ${title}`,
      icon: <ExclamationCircleOutlined style={{ color : colorError}} />,
      content: 'คุณต้องการลบชื่อสารเคมีใช่หรือไม่ ?',
      okText: 'ใช่',
      cancelText: 'ไม่ใช่',
      maskClosable: true,
      okButtonProps: {style: { backgroundColor : colorError}},
      onOk:async() => {
        await handleDeleteChemical(value)
        refreshData();
      },
      onConfirm: () => refreshData()
    });
  };

  const handleDeleteChemical = async(id) => {
    setErrorMessages(null)
    try {
      await DELETE(`${URL_CHEMICAL.QUALITY_CHEMICAL}${id}/`)
    } catch (error) {
      setErrorMessages(error.errorMessages)
    }
  }

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  return(
    <div>
      <ErrorMessages message={errorMessages}/>
      <ColorButton
        type={'primary'}
        override={colorSuccess}
        style={{ float : 'right', marginBottom : 10}}
        icon={<PlusCircleFilled />} 
        onClick={() => setChemicalTarget('add')}>
          {"เพิ่มชื่อสารเคมีคุณภาพ"}
      </ColorButton>

      <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_CHEMICAL.QUALITY_CHEMICAL}
      />

      <AddQualityChemicalModal
        open={chemicalTarget ? true : false}
        onClose={() => setChemicalTarget(null)}
        onUpdate={() => {
          setChemicalTarget(null)
          refreshData();
        }}
        target={chemicalTarget}
      />
    </div>
  )
}